import { Button, Grid, Paper, Stack, TextField, Typography, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import React, { useState } from 'react';
import { ApiProgress } from "../../Utilities/ApiProgress";
import { useProductSettingsContext } from "./context/ProductSettingsContext";
import { ProductSettingsDistributorGrid } from "./components/ProductSettingsDistributorGrid";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';

const ProductSettings = () => {
    const {
        dataLoaded,
        productDefaults,
    } = useProductSettingsContext();
    const [file, setFile] = useState(null);
    const [infoDialogOpen, setInfoDialogOpen] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorData, setErrorData] = useState(null);

    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file first.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch("api/products/productSettings", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                alert("File uploaded successfully!");
            } else {
                const errors = JSON.parse(await response.text());
                setErrorData(errors);
                setErrorDialogOpen(true);
            }
        } catch (error) {
            alert("Error uploading file.");
            console.error("Upload Error:", error);
        }
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile.type !== "text/csv" && !selectedFile.name.endsWith(".csv")) {
            alert("Invalid file type. Please select a CSV file.");
            setFile(null);
        } else {
            setFile(selectedFile);
        }
    };

    return (dataLoaded ? <Paper elevation={1} sx={{ padding: 2, margin: 2 }}>
        <Stack direction='column' spacing={1}>
            <Grid container>
                <Grid item xs={10}>
                    <Typography
                        variant='h4'>{productDefaults.brandFamily} {productDefaults.description} ({productDefaults.sku})</Typography>
                </Grid>
                <Grid item xs={2} direction="row" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TextField
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        id="file-input"
                    />
                    <label htmlFor="file-input">
                        {!file ?
                            <Button variant="contained" component="span">
                                Upload Settings
                            </Button> :
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleUpload}
                                disabled={!file}
                            >
                                Upload
                            </Button>}
                    </label>
                    <IconButton
                        onClick={() => setInfoDialogOpen(true)}
                        size="small"
                        sx={{ color: 'primary.main' }}
                    >
                        <InfoIcon />
                    </IconButton>
                    {file && <Typography variant='h7'>{file.name}</Typography>}
                </Grid>
            </Grid>
            <div style={{ width: "100%", height: "70vh" }}>
                <ProductSettingsDistributorGrid />
            </div>
        </Stack>
        <InfoDialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} />
        <ErrorDialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)} errorData={errorData} />
    </Paper> : <ApiProgress />)
}

export default ProductSettings;